"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ErrorPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
function ErrorPage() {
    const error = (0, react_router_dom_1.useRouteError)();
    let errorMessage;
    if ((0, react_router_dom_1.isRouteErrorResponse)(error)) {
        // error is type `ErrorResponse`
        errorMessage = error.data.message || error.statusText;
    }
    else if (error instanceof Error) {
        errorMessage = error.message;
    }
    else if (typeof error === 'string') {
        errorMessage = error;
    }
    else {
        console.error(error);
        errorMessage = 'Unknown error';
    }
    return ((0, jsx_runtime_1.jsxs)("div", { id: 'error-page', className: 'flex flex-col gap-8 justify-center items-center h-screen bg-white', children: [(0, jsx_runtime_1.jsx)("h1", { className: 'text-4xl font-bold', children: "Oops!" }), (0, jsx_runtime_1.jsx)("p", { children: "Sorry, an unexpected error has occurred." }), (0, jsx_runtime_1.jsx)("p", { className: 'text-slate-400', children: (0, jsx_runtime_1.jsx)("i", { children: errorMessage }) })] }));
}
